import { Confirmation } from "../pages/Confirmation";
import { Error } from "../pages/Error";
import { Languages } from "../pages/Languages/Languages";
import { Login } from "../pages/Login";
// import { Review } from "../pages/Review";
import { Schedule } from "../pages/Schedule";

import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

export const Routing = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path=":language" element={<Languages />}>
            <Route path="" element={<Login />} />  
            <Route path="error" element={<Error />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="confirmation" element={<Confirmation />} />

            <Route
              path="*"
              element={<Navigate to={`/${process.env.REACT_APP_LANG}`} replace />}
            />
          </Route>
        </Routes>
      </Router>
    </>
  );
};
